/* ==========================================================================
   SearcherFli > Client > Openjaw > Row
   ========================================================================== */

/* Import modules */
const { destroyOrigin, addOrigin } = require('../../../origin');
const { destroyDestination, addDestination } = require('../../../destination');
const { destroyCalendar, addCalendar } = require('../../../calendar');
const { addRow, destroyRow } = require('./row');
const { initAddButton, destroyAddButton } = require('./add-button');

const { types, actions } = require('../../../store/actions');

const configuration = require('../../../config');

/* Add */
function addRows(instance) {
    /* Remove class multidestination */
    instance.element.classList.add(configuration().css.multidestination);

    /* Destroy input origin, destination, calendar */
    destroyOrigin(instance);
    destroyDestination(instance);
    destroyCalendar(instance);

    /* Init */
    initRows(instance);

    /* Add existing rows */
    const { rows = [] } = instance.store.select('openjaw');
    rows.forEach((_, index) => addRow(instance, index));
}

/* Init */
function initRows(instance) {
    const panel = instance;

    /* Init add button */
    initAddButton(instance);

    /* Actions */
    panel.actions = {
        ...instance.actions,
        removeRow: payload => {
            return instance.store.dispatch(actions.removeRow(payload));
        },
        setRow: payload => {
            return instance.store.dispatch(actions.setRow(payload));
        },
        changeRow: payload => {
            return instance.store.dispatch(actions.changeRow(payload));
        }
    };

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        removeRow: instance.store.subscribe((_, action) => {
            if (action.type !== types.REMOVE_ROW) return;

            destroyRow(instance, action.payload);
        })
    };

    /* Create default rows */
    const { rows = [] } = instance.store.select('openjaw');
    const { origin, destination, calendar } = instance.store.select('data');
    if (rows.length === 0) {
        panel.actions.setRow({
            index: 0,
            origin,
            destination,
            calendar: [calendar[0]]
        });

        panel.actions.setRow({
            index: 1,
            origin: undefined,
            destination: origin,
            calendar: [calendar[0].fp_incr(4)]
        });
    }
}

/* Destroy all rows */
function destroyRows(instance) {
    if (!instance.rows) return;

    const panel = instance;

    /* Remove from DOM */
    instance.rows
        .filter(item => item)
        .forEach((_, index) => {
            destroyRow(instance, index);
        });

    /* Remove from instance */
    delete panel.rows;

    /* Actions */
    delete panel.actions.removeRow;
    delete panel.actions.setRow;
    delete panel.actions.changeRow;

    /* Reactions */
    panel.reactions.removeRow.unsubscribe();
    delete panel.reactions.removeRow;

    /* Remove add button */
    destroyAddButton(instance);

    /* Remove class multidestination */
    instance.element.classList.remove(configuration().css.multidestination);

    /* Add input origin, destination, calendar */
    addOrigin(instance);
    addDestination(instance);
    addCalendar(instance);
}

module.exports = {
    addRows,
    destroyRows
};
